export function buildPendingClassesWhatsAppUrl(pendingClasses, { schoolName = '', useMalayalam = false } = {}) {
  const lines = (pendingClasses || []).map((c) => {
    const teacher = c.teacher_name && c.teacher_name !== 'Not assigned' ? c.teacher_name : '—';
    return useMalayalam
      ? `• ${c.division_name} (${teacher})`
      : `• ${c.division_name} (${teacher})`;
  });

  const header = useMalayalam
    ? `${schoolName ? `${schoolName} — ` : ''}ഇന്നത്തെ NM ഹാജർ ഇനിയും അപ്‌ഡേറ്റ് ചെയ്തിട്ടില്ല:\n\n`
    : `${schoolName ? `${schoolName} — ` : ''}Today's NM present not updated yet:\n\n`;

  const footer = useMalayalam
    ? '\n\nNMhelper ആപ്പിൽ ആൺ/പെൺ എണ്ണം നൽകി സേവ് ചെയ്യുക. നന്ദി.'
    : '\n\nPlease enter boys/girls counts in NMhelper and save. Thank you.';

  const text = header + lines.join('\n') + footer;
  return `https://wa.me/?text=${encodeURIComponent(text)}`;
}
